// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Set the background of the entire app */
  --ion-color-primary: #E66B00;
  /* Set the font family of the entire app */
  --ion-font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Roboto", sans-serif;
}

@media only screen and (min-width: 768px) and (min-height: 768px) {
  .sc-ion-modal-md-h {
    --width: 600px;
    --height: 800px;
  }
}
#main-menu {
  margin-top: 20px;
}
#main-menu #menu-header {
  padding: 10px;
  border-bottom: 1px solid lightgray;
}
#main-menu #menu-title {
  font-size: 20px;
  margin: 5px 0;
}
#main-menu #menu-subtitle {
  margin: 10px 0;
}
#main-menu ion-label {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACA;EACE,yCAAA;EACA,4BAAA;EAEA,0CAAA;EACA,4FAAA;AADF;;AAIA;EACE;IACI,cAAA;IACA,eAAA;EADJ;AACF;AAMA;EACE,gBAAA;AAJF;AAKE;EACE,aAAA;EACA,kCAAA;AAHJ;AAKE;EACE,eAAA;EACA,aAAA;AAHJ;AAKE;EACE,cAAA;AAHJ;AAQE;EACE,iBAAA;AANJ","sourcesContent":["\r\n:root {\r\n  /* Set the background of the entire app */\r\n  --ion-color-primary: #E66B00;\r\n\r\n  /* Set the font family of the entire app */\r\n  --ion-font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", \"Roboto\", sans-serif;\r\n}\r\n\r\n@media only screen and (min-width: 768px) and (min-height: 768px) {\r\n  .sc-ion-modal-md-h {\r\n      --width: 600px;\r\n      --height: 800px;\r\n  }\r\n}\r\n\r\n\r\n\r\n#main-menu {\r\n  margin-top: 20px;\r\n  #menu-header {\r\n    padding: 10px;\r\n    border-bottom: 1px solid lightgray;\r\n  }\r\n  #menu-title {\r\n    font-size: 20px;\r\n    margin: 5px 0;\r\n  }\r\n  #menu-subtitle {\r\n    margin: 10px 0;\r\n  }\r\n  #menu-icon {\r\n\r\n  }\r\n  ion-label {\r\n    margin-left: 10px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
